export default __webpack_public_path__ + "static/media/editPassword.561a669a.svg";